module.exports = __webpack_public_path__ + "static/media/acctiv_info_survey.bb76201d.png";